import { render, staticRenderFns } from "./CompPeopleTourStagesStations.vue?vue&type=template&id=b65f6532&scoped=true"
import script from "./CompPeopleTourStagesStations.vue?vue&type=script&setup=true&lang=js"
export * from "./CompPeopleTourStagesStations.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompPeopleTourStagesStations.vue?vue&type=style&index=0&id=b65f6532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65f6532",
  null
  
)

export default component.exports